import { Kbd, KbdGroup } from '@/components/ui/kbd'
import { IS_MAC } from './platform'

/**
 * Render one key token as its display label. Modifier tokens map to the
 * platform glyphs (⌘/⌥ on macOS, Ctrl/Alt elsewhere); named keys get friendly
 * labels; single characters are upper-cased.
 */
export function keyLabel(token: string): string {
  switch (token) {
    case 'mod':
      return IS_MAC ? '⌘' : 'Ctrl'
    case 'alt':
      return IS_MAC ? '⌥' : 'Alt'
    case 'shift':
      return IS_MAC ? '⇧' : 'Shift'
    case 'ctrl':
      return 'Ctrl'
    case 'backspace':
      return IS_MAC ? '⌫' : 'Backspace'
    case 'escape':
      return 'Esc'
    case 'tab':
      return 'Tab'
    case 'enter':
      return IS_MAC ? '↵' : 'Enter'
    case '1-9':
      return '1–9'
    case 'interval':
      // A typed interval value, not a single key (see shortcuts-catalog).
      return '5 · 15 · 1h'
    case 'a-z':
      return 'A–Z'
    case 'space':
      return 'Space'
    case 'up-down':
      return '↑↓'
    case 'right':
      return '→'
    case 'drag':
      return 'Drag'
    case 'scroll':
      return 'Scroll'
    case 'hold':
      return 'Hold'
    default:
      return token.length === 1 ? token.toUpperCase() : token
  }
}

/** A horizontal run of keycap chips for a shortcut, e.g. ⌘ + Shift + Z. */
export function Keys({ tokens }: { tokens: string[] }) {
  return (
    <KbdGroup className="shrink-0">
      {tokens.map((t, i) => (
        <Kbd key={i}>{keyLabel(t)}</Kbd>
      ))}
    </KbdGroup>
  )
}
